<template>
  <div>
    <v-row>
      <v-col cols="12">
        <h4 class="ml-3 mr-6" style="display: inline-block">
          {{ title }} {{ titlePrecision }}
        </h4>
        <span v-if="!readOnly">
          <v-tooltip bottom color="error">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="error"
                v-bind="attrs"
                v-on="on"
                @click.stop="promptConfirmDeletion()"
              >
                <v-icon>mdi-collapse-all</v-icon>
              </v-btn>
            </template>
            <span
              >Supprimer {{ isFeminin ? "toutes" : "tous" }} les
              {{ title.toLowerCase() }}</span
            >
          </v-tooltip>
          <v-tooltip bottom color="success">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="success"
                v-bind="attrs"
                v-on="on"
                @click.stop="showAppendBox()"
              >
                <v-icon>mdi-plus-box</v-icon>
              </v-btn>
            </template>
            <span>Ajouter un{{ isFeminin ? "e" : "" }} {{ singulier }}</span>
          </v-tooltip>
        </span>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-data-table
        class="mt-0 ml-3 mb-6"
        :items="items"
        :headers="headers"
        :no-data-text="'Aucun' + (isFeminin ? 'e' : '') + ' ' + singulier"
        hide-default-header
        hide-default-footer
        dense
        disable-pagination
        disable-sort
        disable-filtering
      >
        <template v-slot:[`item.commands`]="{ item }">
          <v-row
            style="flex-wrap: nowrap"
            align="center"
            justify="space-around"
          >
            <v-btn
              v-if="!readOnly"
              icon
              color="error"
              @click.stop="promptConfirmDeletion(item.id)"
            >
              <v-icon>mdi-trash-can</v-icon>
            </v-btn>
          </v-row>
        </template>
      </v-data-table>
    </v-row>

    <v-dialog persistent v-model="showDelConfirm" max-width="410">
      <v-card>
        <v-card-title class="text-h5">
          Confirmation de suppression
        </v-card-title>
        <v-card-text>
          {{ delConfirmMessage }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="doDeletion"> Oui </v-btn>
          <v-btn color="success" text @click="cancelDeletion"> Non </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showAppend" max-width="410">
      <v-card :loading="appendLoading" :disabled="appendLoading">
        <template slot="progress">
          <v-progress-linear
            color="produit"
            height="7"
            indeterminate
          ></v-progress-linear>
        </template>
        <v-card-title class="text-h5"> Ajout </v-card-title>
        <v-card-text>
          Choisissez le ou les élément(s) à ajouter au produit.
          <v-autocomplete
            :label="title"
            :items="appendItems"
            :search-input.sync="appendSearch"
            :loading="appendLoading"
            v-model="toAppendItems"
            item-text="libelle"
            item-value="id"
            multiple
            flat
            small-chips
            deletable-chips
            return-object
          ></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="validateAppend"> OK </v-btn>
          <v-btn color="error" text @click="cancelAppend"> Annuler </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import FournisseurService from "@/services/FournisseurService";
export default {
  name: "ProduitCollection",
  props: {
    title: {
      type: String,
      required: true,
    },
    collection: {
      type: String,
      required: true,
    },
    isFeminin: {
      type: Boolean,
      default: false,
    },
    titlePrecision: {
      type: String,
      default: "",
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      headers: [
        { text: "Intitulé", value: "libelle" },
        { text: "Commandes", value: "commands" },
      ],
      showAppend: false,
      appendLoading: false,
      appendItems: null,
      toAppendItems: null,
      appendSearch: "",
      showDelConfirm: false,
      deleteId: null,
    };
  },
  watch: {
    appendSearch(val) {
      if (this.appendLoading) return;
      this.appendLoading = true;

      this.serviceMethod({ q: val })
        .then((res) => {
          if (this.toAppendItems) {
            this.appendItems = [...this.toAppendItems, ...res.data];
          } else {
            this.appendItems = res.data;
          }
        })
        .catch((err) => {
          if (
            err.response &&
            err.response.status &&
            err.response.status == 401
          ) {
            this.$store.dispatch(
              "setErreur",
              new Error("Vous avez été déconnecté.e")
            );
            this.$router.replace({ name: "home" });
          } else if (
            err.response &&
            err.response.status &&
            err.response.status == 404
          ) {
            this.appendItems = [];
          } else {
            this.$store.dispatch("setErreur", err);
          }
        })
        .finally(() => {
          this.appendLoading = false;
        });
    },
  },
  computed: {
    items() {
      return this.$store.state.demandeEditee.produit[this.collection];
    },
    singulier() {
      return this.title.replace(/s\W/g, " ").replace(/s$/, "").toLowerCase();
    },
    delConfirmMessage() {
      let message = "Confirmez-vous la suppression ";

      if (this.deleteId) {
        let intitule =
          this.items[this.items.findIndex((it) => it.id === this.deleteId)]
            .libelle;
        return (
          message +
          (this.isFeminin
            ? this.collection != "indications"
              ? "de la "
              : "de l'"
            : "du ") +
          this.singulier +
          " " +
          intitule +
          "?"
        );
      } else {
        return (
          message +
          " de " +
          (this.isFeminin ? "toutes" : "tous") +
          " les " +
          this.title.toLowerCase() +
          " ?"
        );
      }
    },
    serviceMethod() {
      switch (this.collection) {
        case "indications":
          return FournisseurService.getIndications;
        case "domaines":
          return FournisseurService.getDomaines;
        case "sterilisations":
          return FournisseurService.getSterilisations;
        case "substances":
          return FournisseurService.getSubstances;
      }
      return null;
    },
  },
  methods: {
    showAppendBox() {
      this.serviceMethod({ all: true })
        .then((res) => {
          this.appendItems = res.data;
        })
        .catch((err) => {
          if (
            err.response &&
            err.response.status &&
            err.response.status == 401
          ) {
            this.$store.dispatch(
              "setErreur",
              new Error("Vous avez été déconnecté.e")
            );
            this.$router.replace({ name: "home" });
          } else if (
            err.response &&
            err.response.status &&
            err.response.status == 404
          ) {
            this.appendItems = [];
          } else if (err instanceof Error) {
            this.$store.dispatch("setErreur", err);
          }
        })
        .finally(() => {
          this.appendLoading = false;
        });
      this.appendItems = null;
      this.toAppendItems = null;
      this.appendLoading = true;
      this.showAppend = true;
    },
    validateAppend() {
      this.toAppendItems.forEach((toApd) => {
        if (this.items.findIndex((it) => it.id == toApd.id) == -1) {
          this.items.push(toApd);
        }
      });
      this.toAppendItems = null;
      this.showAppend = false;
    },
    cancelAppend() {
      this.showAppend = false;
    },
    promptConfirmDeletion(id = null) {
      this.deleteId = id;
      this.showDelConfirm = true;
    },
    doDeletion() {
      let id = this.deleteId;
      let index = this.items.findIndex((it) => it.id == id);
      this.deleteId = null;
      this.showDelConfirm = false;
      if (index !== -1) {
        this.items.splice(index, 1);
      } else {
        this.items.splice(0, this.items.length);
      }
    },
    cancelDeletion() {
      this.deleteId = null;
      this.showDelConfirm = false;
    },
  },
};
</script>

<style></style>
